import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SortablejsModule } from 'ngx-sortablejs';
import { FormlyModule } from '@ngx-formly/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { SharedModule } from '../shared/shared.module';

import { FormBuilderV2StateService } from './services/form-builder-v2-state.service';
import { FormBuilderV2HistoryService } from './services/form-builder-v2-history.service';

import { FbInlineEditComponent } from './components/fb-inline-edit/fb-inline-edit.component';
import { FbAddFieldButtonComponent } from './components/fb-add-field-button/fb-add-field-button.component';
import { FbBlockComponent } from './components/fb-block/fb-block.component';
import { FbSectionComponent } from './components/fb-section/fb-section.component';
import { FormBuilderV2CanvasComponent } from './components/form-builder-v2-canvas/form-builder-v2-canvas.component';
import { FbFieldPropertiesPanelComponent } from './components/fb-field-properties-panel/fb-field-properties-panel.component';
import { FbExpressionEditorComponent } from './components/fb-expression-editor/fb-expression-editor.component';
import { FbExpressionTesterComponent } from './components/fb-expression-tester/fb-expression-tester.component';
import { FbToolbarComponent } from './components/fb-toolbar/fb-toolbar.component';
import { FbFormOutlineComponent } from './components/fb-form-outline/fb-form-outline.component';
import { FbFullscreenEditorComponent } from './components/fb-fullscreen-editor/fb-fullscreen-editor.component';
import { FbContextMenuComponent } from './components/fb-context-menu/fb-context-menu.component';
import { FbResizableLayoutComponent } from './components/fb-resizable-layout/fb-resizable-layout.component';
import { FbFieldWrapperComponent } from './components/fb-field-wrapper/fb-field-wrapper.component';
import { FbComponentPaletteComponent } from './components/fb-component-palette/fb-component-palette.component';

const COMPONENTS: any[] = [
  FbInlineEditComponent,
  FbAddFieldButtonComponent,
  FbBlockComponent,
  FbSectionComponent,
  FormBuilderV2CanvasComponent,
  FbFieldPropertiesPanelComponent,
  FbExpressionEditorComponent,
  FbExpressionTesterComponent,
  FbToolbarComponent,
  FbFormOutlineComponent,
  FbFullscreenEditorComponent,
  FbContextMenuComponent,
  FbResizableLayoutComponent,
  FbFieldWrapperComponent,
  FbComponentPaletteComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SortablejsModule.forRoot({ animation: 200 }),
    FormlyModule,
    NgSelectModule,
    MonacoEditorModule,
    ClipboardModule,
    SharedModule,
  ],
  exports: [...COMPONENTS],
  providers: [FormBuilderV2StateService, FormBuilderV2HistoryService],
})
export class FormBuilderV2Module {}
